import React, { CSSProperties } from 'react';

interface Props {
  title: string
  message: string
  stylesOverride?: CSSProperties
}

const ResultLoadingOverlay = ({ title, message, stylesOverride }: Props) => (
  <div style={stylesOverride}>
    <h3 className="h3" style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: title }} />
    <div className="loading-spinner-2" style={{ margin: '50px auto' }}>
      <div className="bounce1" />
      <div className="bounce2" />
      <div className="bounce3" />
    </div>
    {/* This enables content manager to hide the message area in the way that he sets the loading message as empty string */}
    {message !== '' && <p style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: message }} />}
  </div>
);

export default ResultLoadingOverlay;
